"use client"

import { useEffect } from "react"
import { useUmami } from "@/hooks/useUmami"

export type AnalyticsProps = {
  event: string
  data?: Record<string, any>
}

export default function Analytics({
  event,
  data
}: AnalyticsProps) {
  const { trackEvent } = useUmami()

  useEffect(() => {
    trackEvent(event, data)
  }, [event, data, trackEvent])

  return null
}